export default {
  path: '/teaching',
  name: 'Teaching',
  redirect: '/teaching/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      name: 'Teachinglist',
      component: () => import('@/views/teaching'),
      meta: { requiresAuth: true }
    },
    {
      path: 'detail',
      name: 'TeachingDetail',
      component: () => import('@/views/teaching/detail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'editTeaching',
      name: 'TeachingEdit',
      component: () => import('@/views/teaching/editTeaching'),
      meta: { requiresAuth: true }
    },
    {
      path: 'editMatchPlan',
      name: 'EditTeaching',
      component: () => import('@/views/tutorial/EditMatchTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'addMatchPlan',
      name: 'AddTeaching',
      component: () => import('@/views/tutorial/CreateMatchTutorial'),
      meta: { requiresAuth: true }
    },
    {
      path: 'planDetail',
      name: 'PlanDetail',
      component: () => import('@/views/teaching/planDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: 'editTeachingSecond',
      name: 'EditTeachingSecond',
      component: () => import('@/views/teaching/editTeachingSecond'),
      meta: { requiresAuth: true }
    }
  ]
}
